import css from '../styles.module.scss'

const DefaultCover = () => (
  <img className={css.img} src="/assets/images/default-thumbnail.jpg" />
)

export default DefaultCover
